import { render, staticRenderFns } from "./CheckoutCustomerConfirmation.vue?vue&type=template&id=af520eca&scoped=true&"
import script from "./CheckoutCustomerConfirmation.vue?vue&type=script&lang=js&"
export * from "./CheckoutCustomerConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutCustomerConfirmation.vue?vue&type=style&index=0&id=af520eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af520eca",
  null
  
)

export default component.exports